import { produce } from 'immer'
import createReducer from "./reducerUtils"

const initialState = {
    isCloseSttoper: true,
    chatWordMarkup: null
}

const config = {
    setIsCloseSttoper(state, action) {
        state.isCloseSttoper = action.payload
    },
    setChatWordMarkup(state, action) {
        state.chatWordMarkup = action.payload
    }
}

export default produce(
    (state, action) => createReducer(state, action, config),
    initialState
)

